<template>
  <div>
    <dig-tab @OnChangeTab=OnChangeTab class="padding" :items="items" :selectedIndex.sync="selectedTab">
      <div v-if="selectedTab == 0">
        <div style="padding:10px;">Current Balance : {{balance}}</div>
        <dig-tab class="padding" :items="userItems" :selectedIndex.sync="selectedUserTab">
          <div v-if="selectedUserTab == 0">
            <dig-form :show-title-item=true :title="'Filter'" :items="search.filter" :isLoading="search.isLoading" @OnSubmit="OnSubmitPencarian"></dig-form>
            <div style="margin-top:10px;" v-if="search.result.length === 0">No Results Found</div>
            <table v-if="search.result.length > 0">
              <thead>
                <tr><th>Date</th><th>Desc</th><th>Masuk</th><th>Keluar</th></tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in search.result" :key="index">
                  <td>{{item.tanggal}}</td>
                  <td>{{item.deskripsi}}</td>
                  <td class="align-right">{{ item.is_pengeluaran ? '' : item.nominal }}</td>
                  <td class="align-right">{{ item.is_pengeluaran ? item.nominal : '' }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr><td></td><td class="align-right"></td><td class="align-right">{{ totalMutasi.pemasukan }}</td><td class="align-right">{{ totalMutasi.pengeluaran }}</td></tr>
                <tr><td></td><td></td><td class="align-right">Total</td><td class="align-right">{{ totalMutasi.total }}</td></tr>
              </tfoot>
            </table>
          </div>
          <div v-if="selectedUserTab == 1">
            <dig-form ref="formAdd" :show-title-item=true :title="'Add'" :items="add.form" :isLoading="add.isLoading" @OnSubmit="OnSubmitAdd"></dig-form>
          </div>
        </dig-tab>
      </div>
      <dig-tab v-if="selectedTab == 1" class="padding" :items="adminItems" :selectedIndex.sync="selectedAdminTab">
        <div v-if="selectedAdminTab == 0">
          <dig-form :show-title-item=true :title="'Filter'" :items="updateCashflow.filter" :isLoading="updateCashflow.isLoading" @OnSubmit="OnSearchUpdateCashflow"></dig-form>
          <dig-table @OnAddOn=OnAddOn :items="updateCashflow.table.data" :hidden="updateCashflow.table.hidden" :addOns="updateCashflow.table.addOns"></dig-table>
        </div>
        <dig-crud v-if="selectedAdminTab == 1" :title="jenisCashflow.title" :name="jenisCashflow.endpoint" :formData="jenisCashflow.form" :listHidden="jenisCashflow.hidden" :detailsWidth=60></dig-crud>
      </dig-tab>
    </dig-tab>
    <dig-notif :text="notif.text" :show.sync="notif.show"></dig-notif>
  </div>
</template>

<script>
import Vue from 'vue'
import Tab from '../digilib_web/vue/tab.vue'
import Form from '../digilib_web/vue/form.vue'
import Table from '../digilib_web/vue/table.vue'
import Notif from '../digilib_web/vue/notif.vue'
import { Http } from '../digilib_web/core/digitify.js'
import Crud from './crud.vue'

export default {
  methods: {
    LoadBalance: function() {
      Http.Request(
        'GET', 'balance',
        {
          OnResponse:function(json) {
            this.balance = parseInt(json.balance).toLocaleString();
          }.bind(this)
        }
      );
    },
    OnShow: function() {
      Http.Request(
        'POST', 'cashflow_types/enum',
        {
          data: [{'orderby':'nama'}],
          OnResponse:function(json) {
            this.add.form[0].options = json;
          }.bind(this)
        }
      );
      this.LoadBalance();
    },
    OnChangeTab: function(index) {
      this.LoadBalance();
    },
    OnSearchUpdateCashflow: function(val) {
      this.updateCashflow.isLoading = true;
      var payload = [];
      payload.push({key:'tanggal', operator:'>=', value:val.from + ' 00:00:00'});
      if (val.to) { payload.push({key:'tanggal', operator:'<=', value:val.to + ' 23:59:59'}); }
      if (val.jenis) { payload.push({key:'id_jenis_cashflow', operator:'=', value:val.jenis}); }
      Http.Request(
        'POST', 'cashflows/details',
        {
          data: payload,
          OnResponse:function(json) {
            this.updateCashflow.isLoading = false;
            this.updateCashflow.table.data = json;
          }.bind(this)
        }
      );
    },
    OnSubmitPencarian: function(val) {
      this.search.isLoading = true;
      var payload = [];
      payload.push({'orderby':'tanggal'});
      payload.push({key:'tanggal', operator:'>=', value:val.from + ' 00:00:00'});
      if (val.to) { payload.push({key:'tanggal', operator:'<=', value:val.to + ' 23:59:59'}); }
      if (val.exclude) {
        for (var i = 0; i < val.exclude.length; ++i) {
          payload.push({key:'id_jenis_cashflow', operator:'<>', value:val.exclude[i].id});
        }
      }
      Http.Request(
        'POST', 'cashflows/mutasi',
        {
          data: payload,
          OnResponse:function(json) {
            this.search.isLoading = false;
            this.search.result = json;
          }.bind(this)
        }
      );
    },
    OnSubmitAdd: function(val) {
      this.add.isLoading = true;
      Http.Request(
        'POST', 'cashflows',
        {
          data: val,
          OnResponse:function(json) {
            this.add.isLoading = false;
            if (json.success) {
              this.notif.text = json.msg;
              this.notif.show = true;
              this.$refs.formAdd.SetValues({});
              this.LoadBalance();
            } else {
              alert(json.msg);
            }
          }.bind(this)
        }
      );
    },
    OnAddOn: function(tableIndex, index) {
      //delete
      if (index == 0) {
        if (confirm('Are you sure you want to delete?')) {
          Http.Request(
            'DELETE', 'cashflows',
            {
              'data' : {id:this.updateCashflow.table.data[tableIndex].id},
              OnResponse:function(json) {
                if (json.success) {
                  Vue.delete(this.updateCashflow.table.data, tableIndex);
                }
                alert(json.msg);
              }.bind(this)
            }
          );
        }
      }
    }
  },
  components: {
    'dig-tab': Tab,
    'dig-form': Form,
    'dig-table': Table,
    'dig-notif': Notif,
    'dig-crud': Crud,
  },
  mounted() {
    this.OnShow();
  },
  computed: {
		totalMutasi: function () {
      var pengeluaran = 0, pemasukan = 0, total = 0;
			for (var i = 0; i < this.search.result.length; ++i) {
        var nominal = parseInt(this.search.result[i].nominal);
        if (this.search.result[i].is_pengeluaran) {
          pengeluaran += nominal;
        } else {
          pemasukan += nominal;
        }
      }
      total = pemasukan - pengeluaran;
      return {pengeluaran: pengeluaran.toLocaleString(), pemasukan: pemasukan.toLocaleString(), total: total.toLocaleString()};
		}
	},
  data() {
		return {
      balance:0,
      selectedTab:0,
      selectedUserTab:0,
      selectedAdminTab:0,
			items: [
        {title:'User', icon:'fa fa-user'},
        {title:'Admin', icon:'fa fa-at'},
      ],
      adminItems: [
        {title:'Cashflow'},
        {title:'Jenis Cashflow'}
      ],
      jenisCashflow: {
        title: 'Jenis Cashflow',
        endpoint: 'cashflow_types',
        form: [
          {name:'nama', title:'nama', inputType:'input', required:true},
          {name:'is_pengeluaran', title:'tipe', inputType:'select', required:true, options: [{id:0, name:'Pemasukan'}, {id:1, name:'Pengeluaran'}]},
        ],
        hidden: ['id', 'is_pengeluaran']
      },
      updateCashflow: {
        filter: [
          {name:'from', title:'Dari', inputType:'calendarpicker', required:true},
          {name:'to', title:'Sampai', inputType:'calendarpicker'},
        ],
        table: {
          data: [],
          hidden: ['id', 'id_jenis_cashflow'],
          addOns: [
            // {text:'update', type:'details'},
            {text:'delete', type:'delete'}
          ]
        },
        isLoading: false,
      },
      userItems: [
        {title:'Mutasi'},
        {title:'Add Cashflow'}
      ],
      search: {
        filter: [
          {name:'from', title:'Dari', inputType:'calendarpicker', required:true},
          {name:'to', title:'Sampai', inputType:'calendarpicker'},
          // {name:'jenis', title:'Jenis', inputType:'select', options:[]},
          {name:'exclude', title:'Exclude', inputType:'autocompletelist', endpoint:'cashflow_types/enum', tag:'nama'},
        ],
        result: [],
        isLoading: false,
      },
      add: {
        form: [
          {name:'id_jenis_cashflow', title:'Jenis', inputType:'select', options:[], required:true},
          {name:'tanggal', title:'Tanggal', inputType:'calendarpicker', required:true},
          {name:'deskripsi', title:'Deskripsi', inputType:'input', required:true},
          {name:'nominal', title:'Nominal', inputType:'input', type:'number', required:true},
        ],
        isLoading: false,
      },
      notif: {text:'', show:false}
		}
	},
}
</script>

<style scoped>
</style>
